import React from 'react';

function TrackAndTraceIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M40.9999 14.5557L23.9999 24.0001M23.9999 24.0001L6.99993 14.5557M23.9999 24.0001L24 43.0002M28 41.7779L25.5541 43.1368C24.9869 43.4519 24.7032 43.6095 24.4029 43.6712C24.1371 43.7259 23.8629 43.7259 23.5971 43.6712C23.2968 43.6095 23.0132 43.4519 22.4459 43.1368L7.64594 34.9146C7.04691 34.5818 6.74737 34.4154 6.52927 34.1787C6.33632 33.9693 6.19029 33.7212 6.10097 33.4508C6 33.1452 6 32.8026 6 32.1173V15.8831C6 15.1978 6 14.8551 6.10097 14.5495C6.19029 14.2792 6.33632 14.031 6.52927 13.8216C6.74737 13.585 7.0469 13.4186 7.64594 13.0858L22.4459 4.86353C23.0131 4.54842 23.2968 4.39086 23.5971 4.32909C23.8629 4.27442 24.1371 4.27442 24.4029 4.32909C24.7032 4.39086 24.9869 4.54842 25.5541 4.86353L40.3541 13.0858C40.9531 13.4186 41.2526 13.585 41.4707 13.8216C41.6637 14.031 41.8097 14.2792 41.899 14.5495C42 14.8551 42 15.1978 42 15.8831L42 19.0002M15 9.00017L33 19.0002"
          stroke="#111111"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37 24C33.1341 24 30 27.256 30 31.2726C30 33.5694 30.875 35.355 32.625 36.9501C33.8586 38.0744 35.3529 39.9419 36.2499 41.4555C36.6803 42.1815 37.2888 42.1815 37.7501 41.4555C38.6926 39.972 40.1414 38.0744 41.375 36.9501C43.125 35.355 44 33.5694 44 31.2726C44 27.256 40.8659 24 37 24Z"
          stroke="#111111"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle cx="37" cy="31" r="2" fill="#111111" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TrackAndTraceIcon;
